import React, { memo } from 'react';
import {
  GoogleMap,
  DirectionsService,
  DirectionsRenderer,
  TrafficLayer
} from '@react-google-maps/api';
import PropTypes from 'prop-types';

const containerStyle = {
  width: '100%',
  height: '40rem'
};

function DigitalDispatchGoogleMap({
  onLoad,
  onUnmount,
  startLocationToEndLocationDirectionResponse,
  directionsServiceCallback,
  dispatchPickUpLocation,
  dispatchDropOffLocation,
  children,
  zoom,
  center
}) {
  const dropOffAddressCoordinates = {
    lat: dispatchDropOffLocation.latitude,
    lng: dispatchDropOffLocation.longitude
  };
  const pickUpAddressCoordinates = {
    lat: dispatchPickUpLocation.latitude,
    lng: dispatchPickUpLocation.longitude
  };

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={zoom}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      {!startLocationToEndLocationDirectionResponse
        && (
          <DirectionsService
            options={{
              origin: pickUpAddressCoordinates,
              destination: dropOffAddressCoordinates,
              travelMode: window.google.maps.TravelMode.DRIVING
            }}
            // eslint-disable-next-line react/jsx-no-bind
            callback={directionsServiceCallback}
          />
        )}
      {startLocationToEndLocationDirectionResponse
        && (
          <>
            <DirectionsRenderer
              options={{
                directions: startLocationToEndLocationDirectionResponse,
                preserveViewport: true,
              }}
            />
            <TrafficLayer />
          </>
        )}
      {children}
    </GoogleMap>
  );
}

DigitalDispatchGoogleMap.propTypes = {
  onLoad: PropTypes.func,
  onUnmount: PropTypes.func,
  // google.maps.DirectionsResult
  startLocationToEndLocationDirectionResponse: PropTypes.object,
  directionsServiceCallback: PropTypes.func,
  dispatchPickUpLocation: PropTypes.shape({
    addressId: PropTypes.number,
    fullAddress: PropTypes.string,
    googleLocationId: PropTypes.string,
    address: PropTypes.string,
    city: PropTypes.string,
    stateProvidence: PropTypes.string,
    postalCode: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    addressTypeId: PropTypes.number,
    locationName: PropTypes.string
  }),
  dispatchDropOffLocation: PropTypes.shape({
    addressId: PropTypes.number,
    fullAddress: PropTypes.string,
    googleLocationId: PropTypes.string,
    address: PropTypes.string,
    city: PropTypes.string,
    stateProvidence: PropTypes.string,
    postalCode: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    addressTypeId: PropTypes.number,
    locationName: PropTypes.string
  }),
  children: PropTypes.node,
  zoom: PropTypes.number,
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  })
};

export default memo(DigitalDispatchGoogleMap);
